import axios from "@/plugins/axios";

let url = "/api/v1/history";

export const history = {
    post(){
        return axios.post(`${url}`).then(result => result.data);
    },
}
